import { bool, elementType, func, node, number, shape, string } from 'prop-types';
export const baseFormFieldPropTypes = {
    /** Displayed above the field using an accessible label */
    label: node,
    /** Component to use for the label element - 'label' by default */
    labelComponent: elementType,
    /** Allows dummy fields to be created which can have no name, and therefore won't be submitted, such as for sensitive fields */
    isDummy: bool,
    /** A unique name for the field - this controls how the input data is labelled in the form's output */
    name: string.isRequired,
    /** If true, the label will gain an asterisk to indicate that the field is mandatory */
    required: bool,
    /** Error text shown if this field is required but left empty. If the `required` prop is not set, this does nothing */
    emptyMessage: node,
    /** If true, the field will be non-interactive */
    disabled: bool,
    /** An explanation for the user of how to use the field */
    description: node,
    /** A function that returns the validation for the given value of this field, or `undefined` if the field is valid. This may be an asynchronous function. */
    validate: func,
    /** The React component used to render the interactive bit of the field (the 'input') */
    component: elementType.isRequired,
    /** These extra props will be supplied to the `component` during rendering */
    inputProps: shape({}),
    /** These extra props will be supplied to the `useField` hook from react-final-form */
    fieldProps: shape({}),
    /** If true, the component will not have the usual top margin */
    noTopSpacer: bool,
    /** CSS class applied to the field */
    className: string,
    /** HTML id applied to the field */
    id: string,
    /** time in milliseconds to debounce the field **/
    delay: number,
    /** minimum number of characters to trigger submission **/
    minimum: number,
    /** if true, the field will automatically submit its parent `Form` **/
    canSubmit: bool,
    type: string,
    /**  Allow removing the default label in case a fieldset is used (label added to <legend>) */
    showLabel: bool,
    /** if true the error alert will not show for the field when it is in error. */
    hideErrorAlert: bool,
    /** Comparison function to check current values against initial values
     *  of the shape (currentValue: any, initialValue: any) => bool
     *  Defaults to === */
    isEqual: func,
    /** If true, character counter underneath form field is hidden */
    hideCharacterCount: bool,
};
//# sourceMappingURL=BaseFormFieldPropTypes.js.map